import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "input-item",
    style: _normalizeStyle(_ctx.width !== 0 ? { width: `${_ctx.width}px` } : undefined)
  }, [
    _createElementVNode("p", {
      class: _normalizeClass(["title", { 'is-change-font': _ctx.isChangeFont }])
    }, [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      (_ctx.isRequired)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, "必須"))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["input", { multiple: _ctx.isMultiple }])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.icon !== '')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: _normalizeClass(["icon", { 'is-absolute': _ctx.isAbsolute }]),
            src: require(`@/assets/images/${_ctx.icon}`),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('icon-clicked')))
          }, null, 10, _hoisted_2))
        : _createCommentVNode("", true)
    ], 2),
    (!_ctx.isError)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["description", { 'dark-gray': _ctx.isDarkGray }]),
          innerHTML: _ctx.description
        }, null, 10, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.isError)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "error",
          textContent: _toDisplayString(_ctx.errorMessage)
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.isUserNameAvailable)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: "available",
          textContent: _toDisplayString(_ctx.availableMessage)
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "other", {}, undefined, true)
  ], 4))
}